import { useEffect, useState } from 'react';
import studentAssignmentServices from 'ApiService/Placement/studentAssignmentServices';
import ViewAssignedJobs from 'pages/PlacementAdmin/AssignJob/ViewAssignedJobs';

const SingleStudentData = ({ selectedStudent, handleBackClick }) => {
  const studentId = selectedStudent._id;
  const [staffNotes, setStaffNotes] = useState('');

  useEffect(() => {
    const fetchStaffNotes = async () => {
      try {
        const response =
          await studentAssignmentServices.getStudentStaffNotes(studentId);
        if (response.data.success) {
          setStaffNotes(response.data.data.staffNotes || '');
        }
      } catch (error) {
        console.error('Failed to fetch staff notes', error);
      }
    };
    fetchStaffNotes();
  }, [studentId]);

  return (
    <div className="flex h-full w-full flex-col items-center justify-center p-2">
      <button
        onClick={handleBackClick}
        className="absolute right-4 top-4 h-10 w-10 rounded-full bg-brand-500 text-lg text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
      >
        &lt;
      </button>
      <div className="mx-auto mt-7 flex w-full max-w-6xl flex-col gap-6 text-navy-700 dark:text-white">
        <div className="w-full rounded-lg border border-double border-brand-500 bg-white p-6 shadow-md dark:bg-navy-900">
          <div className="mb-4 flex justify-center">
            <div className="flex h-32 w-32 items-center justify-center rounded-full bg-gray-300">
              <span className="text-gray-600">Image will be here</span>
            </div>
          </div>
          <h2 className="mb-2 text-center text-xl font-bold">
            {selectedStudent.name}
          </h2>
          <p className="mb-1 text-center">Email: {selectedStudent.email}</p>
          <p className="mb-1 text-center">
            Contact: {selectedStudent.contactNumber}
          </p>
        </div>

        {/* Staff Notes (internal, not visible to student) */}
        <div className="w-full rounded-lg border border-dashed border-brand-500 bg-white p-6 shadow-md dark:bg-navy-900">
          <h3 className="mb-1 text-lg font-semibold text-brand-600 dark:text-white">
            Staff Notes
          </h3>
          <p className="mb-3 text-xs text-gray-500 dark:text-gray-400">
            Internal – not visible to student
          </p>
          <p className="whitespace-pre-wrap text-gray-700 dark:text-gray-300">
            {staffNotes || '—'}
          </p>
        </div>

        <div className="w-full rounded-lg border border-brand-500 bg-white p-6 shadow-md dark:bg-navy-900">
          <ViewAssignedJobs studentId={studentId} />
        </div>
      </div>
    </div>
  );
};

export default SingleStudentData;
